var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TableText',{attrs:{"prop":"display_name","label":"名称","width":120}}),_c('TableText',{attrs:{"prop":"volley_number","label":"齐发数","width":120}}),_c('TableText',{attrs:{"prop":"promoted_number","label":"晋级数","width":120}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }